
import { Body, Controller, Post, Req } from '@nestjs/common';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { RmIndentQtyLimitService } from './rm-indent-qty-limit.service';
import { RmIndentQtyLimitDTO } from './dto/rm-indent-qty-limit.dto';
import { RmIndentQtyLimitRequest } from './dto/rm-indent-qty-limit.request';
import { AllRmIndentQtyLimitResponse, RmIndentQtyLimitResponse } from '@gtpl/shared-models/raw-material-procurement';
import { ApiTags } from '@nestjs/swagger';

@ApiTags('rm-indent-qty-limit')
@Controller('rm-indent-qty-limit')
export class RmIndentQtyLimitController {
    constructor(
        private rmIndentQtyLimitService: RmIndentQtyLimitService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler,
      ) {}
     /**
     * creates  a Rm Indent Qty Limit
     * @param RmIndentQtyLimitDto RmIndentQtyLimit DTO
     * @returns  rmIndentQtyLimitResponse
     */
  @Post('/createRmIndentQtyLimit')
  async createRmIndentQtyLimit(@Body() rmIndentQtyLimitDTO:RmIndentQtyLimitDTO): Promise<RmIndentQtyLimitResponse> {
    console.log('rmIndentQtyLimitDTO',rmIndentQtyLimitDTO) 
    try {
       return await this.rmIndentQtyLimitService.createRmIndentQtyLimit(rmIndentQtyLimitDTO,false);
     } catch (error) {
          return this.applicationExceptionHandler.returnException(RmIndentQtyLimitResponse, error);
     }
   }

    /**
     * gets all the Value rm Indent Qty Limit
     * @returns AllRmIndentQtyLimitResponse which returns all the Value rm-Indent-Qty-Limite  along with status (true/false), errortype, errorCode, internal message which provides message to the calling function.
     */

     @Post('/getAllRmIndentQtyLimit')
    async getAllRmIndentQtyLimit(): Promise<AllRmIndentQtyLimitResponse> {
        try {
            return await this.rmIndentQtyLimitService.getAllRmIndentQtyLimit();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllRmIndentQtyLimitResponse, error);
        }
    }

      /**
     * Activate Or De-Activate Value rmIndentQtyLimit
     * @param getSingleRmIndentQtyLimit rmIndentQtyLimit
     * @returns Value RmIndentQtyLimit
     */
       @Post('/activateOrDeactivateRmIndentQtyLimit')
       async activateOrDeactivateRmIndentQtyLimit(@Body() rmIndentQtyLimitReq: RmIndentQtyLimitRequest): Promise<RmIndentQtyLimitResponse> {
           try {
             console.log("Controller")
               return await this.rmIndentQtyLimitService.activateOrDeactivateRmIndentQtyLimit(rmIndentQtyLimitReq);
           } catch (err) {
               return this.applicationExceptionHandler.returnException(RmIndentQtyLimitResponse, err);
           }
       }
       /**
     *  updates a  value rm Indent Qty Limit
     * @param RmIndentQtyLimitDto Rm  Indent Qty Limit DTO
     * @returns RmIndentQtyLimitResponse
     */
    @Post('/updateRmIndentQtyLimit')
    async updateRmIndentQtyLimit(@Body() rmIndentQtyLimitDTO:RmIndentQtyLimitDTO): Promise<RmIndentQtyLimitResponse> {
        try {
         return await this.rmIndentQtyLimitService.createRmIndentQtyLimit(rmIndentQtyLimitDTO,true);
       } catch (error) {
            return this.applicationExceptionHandler.returnException(RmIndentQtyLimitResponse, error);
       }
     }
}

